import { render, staticRenderFns } from "./NewsCategoryFilter.vue?vue&type=template&id=43eaba20&"
import script from "./NewsCategoryFilter.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports